import React, { useEffect, useState, useRef, useContext, useCallback } from 'react';
import Container from '@/components/container';
import FilterTag from '@/components/filter-tag';
import apis from '../../apis';
import FilterForm from '../filter-form';
import Dongdong from '@/components/dongdong';
import { STATUS_TYPE_MAP, STATUS_TYPE_COLOR_MAP } from '../../data';
import { Table, message, Popover, Input, Button } from 'antd';
const { TextArea } = Input;
import Copy from '@/components/copy';
import { goto, getQuery } from '@/common/utils';
import './index.less';
import RejectReason from '@/components/reject-reason';
import DetailDrawer from '../detail-pop';
import TabContext from '../../TabContext';
import { InfoCircleOutlined } from '@ant-design/icons';
import { enhancedFormateTimeStamp } from '@/common/utils/format-time';
import IconTip from '@/components/icon-tip';
import useTabSetting from '../../useTabSetting';

const MyApprove = (props) => {
  useTabSetting(true);
  const drawerRef = useRef(null);
  const channelIdQuery = getQuery('channelId');
  const [loading, setLoading] = useState(false);
  const [channelList, setChannelList] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  // const [reason, setReason] = useState('');
  const [flowInfo, setFlowInfo] = useState({});
  const [detailData, setDetailData] = useState({});
  const [visible, setVisible] = useState(false);
  const [rejectChannelId, setRejectChannelId] = useState({}); // rejectChannelId, operate
  const TabSetting = useContext(TabContext);
  const [selectStatus, setSelectStatus] = useState();
  const [disabled, setDisabled] = useState(false);
  const [conditions, setConditions] = useState({
    keyword: channelIdQuery ? channelIdQuery : undefined,
    category: undefined,
    ownerErp: undefined,
    organizationName: undefined,
    createTimeBegin: undefined,
    createTimeEnd: undefined,
    status: null,
    currentPage: 1,
    pageSize: 10,
  });
  const [data, setData] = useState({
    list: [],
    totalCount: 0,
  });
  const columns = [
    {
      align: 'left',
      title: '微频道名称/ID',
      width: 300,
      fixed: 'left',
      render: (data) => {
        return (
          <div>
            <a
              onClick={() => {
                getDetail(data.channelId);
                drawerRef.current.show();
              }}
            >
              {data.name}
            </a>
            <div>
              <Copy size="small" text={data.channelId}>
                微频道ID：{data.channelId}
              </Copy>
            </div>
          </div>
        );
      },
    },
    {
      align: 'left',
      title: '通天塔项目名称/ID',
      width: 200,
      render: (data) => {
        return (
          <div>
            <a
              onClick={() => {
                goto(data.towerPageLink, 'newTab');
              }}
            >
              {data.towerName}
            </a>
            <div>
              <Copy size="small" text={data.towerId}>
                微频道ID：{data.towerId}
              </Copy>
            </div>
          </div>
        );
      },
      width: 200,
    },
    {
      align: 'left',
      title: '页面标题',
      width: 200,
      dataIndex: 'mainTitle',
    },
    {
      align: 'left',
      title: '页面副标题',
      width: 200,
      dataIndex: 'lessTitle',
    },
    {
      align: 'left',
      title: '组长',
      width: 140,
      render: (data) => {
        return <Dongdong name={data.realName} erp={data.ownerErp} />;
      },
    },
    {
      align: 'left',
      title: '部门',
      width: 200,
      dataIndex: 'organizationName',
    },
    {
      align: 'left',
      title: (
        <>
          状态
          <IconTip title="微频道需要先入驻再上场，入驻审核通过后，由上场审核组成员审核上场。" />
        </>
      ),
      width: 140,
      fixed: 'right',
      dataIndex: 'auditingStatus',
      render: (data, record) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div className="channel-micro-my-approve-point" style={{ background: STATUS_TYPE_COLOR_MAP[data] }}></div>
            <span>
              {STATUS_TYPE_MAP[data]}
              {(data === 3 || data === 6) && (
                <Popover
                  content={
                    <div style={{ maxWidth: '248px' }}>
                      <>
                        {record.reason && (
                          <div style={{ color: 'rgba(0, 0, 0, 0.82)', fontSize: '14px', fontWeight: '400' }}>
                            驳回原因：{record.reason}
                          </div>
                        )}
                        <span style={{ color: 'rgba(0, 0, 0, 0.45)', fontSize: '12px', fontWeight: '400' }}>
                          {record.erp && <Dongdong name={record.auditingName} erp={record.erp} size="small" />}
                          <span style={{ marginLeft: '12px' }}>
                            {enhancedFormateTimeStamp(record.updateTime, 'MM-DD hh:mm')}
                          </span>
                        </span>
                      </>
                    </div>
                  }
                >
                  <InfoCircleOutlined style={{ fontSize: '14px', marginLeft: '6px', cursor: 'pointer' }} />
                </Popover>
              )}
            </span>
          </div>
        );
      },
    },
    {
      align: 'left',
      title: '操作',
      width: 300,
      fixed: 'right',
      render: (data) => {
        return (
          <div style={{ display: 'flex' }}>
            {data.button.map((item, index) => {
              return (
                <div key={index}>
                  {item === 'detail' && (
                    <a
                      style={{ marginRight: '12px' }}
                      onClick={() => {
                        getDetail(data.channelId);
                        drawerRef.current.show();
                      }}
                    >
                      查看详情
                    </a>
                  )}
                  {item === 'approve' && (
                    <a
                      style={{ marginRight: '12px' }}
                      onClick={() => {
                        // 3: 已入驻 operate: 5 上场审核通过
                        channelMicroStatusEvent({ channelId: data.channelId, operate: data.status === 3 ? 5 : 2 });
                      }}
                    >
                      通过
                    </a>
                  )}
                  {item === 'reject' && (
                    <a
                      style={{ marginRight: '12px' }}
                      onClick={() => {
                        setRejectChannelId({ channelId: data.channelId, operate: data.status === 3 ? 6 : 3 });
                        setVisible(true);
                      }}
                    >
                      驳回
                    </a>
                  )}
                </div>
              );
            })}
          </div>
        );
      },
    },
  ];

  //获取状态数量
  const getCount = useCallback(() => {
    apis.channelMicroStatusCount({ type: 3 }).then((res) => {
      const {
        ret,
        data: { approve = '', approved = '' },
      } = res;
      if (ret === '0') {
        if (approve === 0) {
          TabSetting.setNum(0);
        }
        const tagInfo = [
          {
            id: null,
            value: '全部',
          },
          {
            id: 1,
            value: '待我审核(' + approve + ')',
          },
          {
            id: 2,
            value: '已审核的(' + approved + ')',
          },
        ];
        setChannelList(tagInfo);
      }
    });
  }, [TabSetting]);

  useEffect(() => {
    getCount();
  }, [getCount]);

  useEffect(() => {
    setLoading(true);
    apis.channelMicroMyApprove({ ...conditions }).then((res) => {
      setLoading(false);
      const { ret, data } = res;
      if (ret === '0') {
        setData(data);
      }
    });
  }, [conditions]);

  useEffect(() => {
    if (!channelIdQuery) return;
    getDetail(channelIdQuery);
    drawerRef.current.show();
  }, [channelIdQuery]);

  const updateParam = (param) => {
    getCount();
    setConditions({ ...conditions, ...param });
  };

  const onSelectChange = (selectedRowKeys, selectedRows) => {
    const arr = selectedRows.filter((item) => {
      return item.status === 2;
    });
    if ((selectedRows.length > 0 && arr.length === 0) || arr.length === selectedRows.length) {
      setDisabled(false);
      if (selectedRows.length > 0) {
        setSelectStatus(selectedRows[0].status);
      }
    } else {
      setDisabled(true);
    }

    setSelectedRowKeys(selectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      disabled: (record.status !== 3 && record.status !== 2) || (record.button && record.button.length <= 1),
    }),
  };
  //通过或者驳回
  const channelMicroStatusEvent = (param) => {
    apis.channelMicroStatusEvent({ ...param }).then((res) => {
      const { ret, msg } = res;
      if (ret === '0') {
        setSelectedRowKeys([]);
        message.success('操作成功');
        setConditions({ ...conditions, currentPage: 1, pageSize: 10 });
        getCount();
      } else {
        message.error(msg);
      }
    });
  };

  function getDetail(channelId) {
    if (!channelId) return;
    apis.channelMicroGetChannel({ channelId }).then((res) => {
      const { ret, data, msg } = res;
      if (ret === '0') {
        setDetailData(data);
      } else {
        message.error(msg);
      }
    });
  }

  return (
    <Container margin={{ vertical: true }}>
      {channelList.length > 0 && (
        <div style={{ display: 'flex', marginBottom: '16px' }}>
          微频道状态：
          <FilterTag.Group
            defaultValue={null}
            onChange={(value) => {
              setConditions({ ...conditions, status: value, currentPage: 1 });
              getCount();
              setSelectedRowKeys([]);
            }}
          >
            {channelList.map((item) => {
              return (
                <FilterTag value={item.id} key={item.id}>
                  {item.value}
                </FilterTag>
              );
            })}
          </FilterTag.Group>
        </div>
      )}
      <FilterForm updateParam={updateParam} />
      <div style={{ marginTop: '24px', display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
        <span style={{ marginRight: '16px' }}>{disabled ? '仅支持对处于同一审核状态的微频道进行批量操作' : ''}</span>
        <Button
          type="primary"
          shape="round"
          ghost
          disabled={disabled}
          style={{ marginRight: '16px' }}
          onClick={() => {
            if (!selectedRowKeys.length) return;
            let channelId = selectedRowKeys.join(',');
            channelMicroStatusEvent({ channelId, operate: selectStatus === 3 ? 5 : 2 });
          }}
        >
          批量通过
        </Button>
        <Button
          type="primary"
          shape="round"
          ghost
          disabled={disabled}
          onClick={() => {
            if (!selectedRowKeys.length) return;
            let channelId = selectedRowKeys.join(',');
            // TODO: 有问题
            setRejectChannelId({ channelId: channelId, operate: selectStatus === 3 ? 6 : 3 });
            setVisible(true);
          }}
        >
          批量驳回
        </Button>
      </div>
      <div style={{ marginTop: '24px' }}>
        <Table
          rowKey="channelId"
          columns={columns}
          rowSelection={rowSelection}
          scroll={{ x: 1300 }}
          loading={loading}
          dataSource={data.list}
          pagination={{
            current: conditions.currentPage,
            total: data.totalCount,
            pageSize: conditions.pageSize,
            onChange: (toPage, pageSize) => {
              setSelectedRowKeys([]);
              setConditions({
                ...conditions,
                currentPage: toPage,
                pageSize: pageSize,
              });
            },
          }}
        />
      </div>
      <DetailDrawer ref={drawerRef} data={detailData} channelMicroStatusEvent={channelMicroStatusEvent} />

      <RejectReason
        visible={visible}
        onCancel={() => {
          setVisible(false);
        }}
        onOk={(reason) => {
          channelMicroStatusEvent({ channelId: rejectChannelId.channelId, operate: rejectChannelId.operate, reason });
          setVisible(false);
        }}
      />
    </Container>
  );
};
export default MyApprove;
